<template>
  <Badge
    :status="status"
    class="tw-capitalize"
    resizable
  >
    {{ entityType }}
  </Badge>
</template>

<script setup>
import { computed } from 'vue';
import { Badge } from '@stakeui';

const props = defineProps({
  entityType: {
    type: String,
    required: true,
  },
});

const TYPE_BADGES = {
  'household': 'warning',
  'group': 'warning',
  'person': 'info',
  'prospect': 'info',
  'client': 'success',
};

const status = computed(() => {
  const lowered = props.entityType.toLowerCase();

  if (lowered in TYPE_BADGES) {
    return TYPE_BADGES[lowered];
  }

  return '';
});
</script>
